import { Eye, X } from "lucide-react";
import { useMemberPreview } from "@/hooks/useMemberPreview";
import { Button } from "@/components/ui/button";

/**
 * Fixed banner shown while an admin is in "Preview as member" mode so they
 * always know the view is simulated and can exit from anywhere.
 */
const MemberPreviewBanner = () => {
  const { isPreviewing, disable } = useMemberPreview();

  if (!isPreviewing) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[80] border-t border-[hsl(var(--accent))]/50 bg-[hsl(var(--brand))] text-primary-foreground shadow-lg">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-2 px-4 py-2 text-xs sm:text-sm">
        <span className="inline-flex items-center gap-1.5 font-medium">
          <Eye className="h-4 w-4 text-[hsl(var(--accent))]" />
          Viewing as a generic member — admin &amp; LifeMart extras hidden
        </span>
        <Button
          size="sm"
          variant="secondary"
          className="h-7 gap-1 px-2 text-xs font-semibold"
          onClick={disable}
        >
          <X className="h-3.5 w-3.5" />
          Exit preview
        </Button>
      </div>
    </div>
  );
};

export default MemberPreviewBanner;
